// extracted by mini-css-extract-plugin
export default {"content":"StoreClusterDetail_content__iL3u3","stores":"StoreClusterDetail_stores__YWqUn"};